export enum SearchParamTypes {
  PAGE = 'page',
  SIZE = 'size',
  SEARCH = 'search',
  LANG = 'lang',
  FILTER = 'filter',
  GATEWAY_ID = 'gatewayId',
  ASSET_ID = 'assetId',
  PROJECT_ID = 'projectId',
  INCLUDE_SHARED = 'includeShared',
  INCLUDE_SENSORS_STATE = 'includeSensorsState',
  TYPE = 'type',
  SORT = 'sort',
  SHOW_VISIBLE = 'showVisible',
}

export enum SearchParamPayloadTypes {
  PAGE_PAYLOAD = 'page[number]',
  SIZE_PAYLOAD = 'page[size]',
  SEARCH_PAYLOAD = 'search',
  LANG_PAYLOAD = 'lang',
  FILTER_PAYLOAD = 'filter',
  GATEWAY_ID_PAYLOAD = 'gateway_id',
  ASSET_ID_PAYLOAD = 'asset_id',
  PROJECT_ID_PAYLOAD = 'project_id',
  INCLUDE_SHARED_PAYLOAD = 'include_shared',
  INCLUDE_SENSORS_STATE_PAYLOAD = 'include_sensors_state',
  TYPE_PAYLOAD = 'type',
  SORT_PAYLOAD = 'sort',
  SHOW_VISIBLE_PAYLOAD = 'show_visible',
}

export type UrlParam = string | null;

export interface PaginationMetaPayload {
  total_pages: number;
  page_size: number;
  results: number;
  all_results: number;
}

export interface PaginationLinkPayload {
  self: string;
  first: string;
  prev: string;
  next: string;
  last: string;
}

export interface PaginationFiltersAppliedPayload {
  field: string;
  type: string;
  arguments: string[];
}

export interface PaginationFiltersCapabilityPayload {
  [key: string]: string[];
}

export interface PaginationFiltersPayload {
  applied: PaginationFiltersAppliedPayload;
  capability: PaginationFiltersCapabilityPayload;
}

export interface ParamsResponsePayload {
  meta?: PaginationMetaPayload;
  links?: PaginationLinkPayload;
  filters?: PaginationFiltersPayload;
}

export interface PaginationMetaModel {
  totalPages: number;
  pageSize: number;
  results: number;
  allResults: number;
}

export interface PaginationLinkModel {
  self: string;
  first: string;
  prev: string;
  next: string;
  last: string;
}

export interface PaginationFiltersAppliedModel {
  field: string;
  type: string;
  arguments: string[];
}

export interface PaginationFiltersCapabilityModel {
  [key: string]: string[];
}

export interface PaginationFiltersModel {
  applied: PaginationFiltersAppliedModel;
  capability: PaginationFiltersCapabilityModel;
}

export interface ParamsResponseModel {
  links?: PaginationLinkModel | null;
  meta?: PaginationMetaModel | null;
  filters?: PaginationFiltersModel | null;
}
